import queryString from 'query-string'

export class Api {

	constructor( apiEndpoints ) {
		this.apiEndpoints = apiEndpoints
	}

	getPrograms( filters ) {

		let filtersCopy = { ...filters }

		return new Promise(( resolve, reject ) => {

			/* Format taxonomies for our api request */
			let taxString = '';
			if ( filtersCopy.tax ) {
				for ( let taxonomySlug in filtersCopy.tax ) {
					let terms = encodeURI( filtersCopy.tax[ taxonomySlug ].join(',') )
					taxString += `&tax[${taxonomySlug}]=${terms}`
				}

				delete filtersCopy.tax
			}

			let queryParams = '?' + queryString.stringify( filtersCopy ) + taxString

			fetch( this.apiEndpoints.getPrograms + queryParams )
				.then( response => {
					if ( 200 !== response.status ) {
						reject( response )
					}

					return response.json()
				})
				.then( data => {
					resolve( data )
				})
			
		})
	}

	getTaxonomyOptions() {
		return new Promise(( resolve, reject ) => {
			fetch( this.apiEndpoints.getTaxonomies )
				.then( response => {
					if ( 200 !== response.status ) {
						reject( response )
					}

					return response.json()
				})
				.then( data => {
					resolve( data )
				})
		})
	}
}